import { render, staticRenderFns } from "./historicalSalary.vue?vue&type=template&id=04822092&scoped=true&"
import script from "./historicalSalary.vue?vue&type=script&lang=js&"
export * from "./historicalSalary.vue?vue&type=script&lang=js&"
import style0 from "./historicalSalary.vue?vue&type=style&index=0&id=04822092&prod&lang=scss&scoped=true&"
import style1 from "./historicalSalary.vue?vue&type=style&index=1&id=04822092&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04822092",
  null
  
)

export default component.exports